<template>
<span>
  <slot name='prepend' ></slot>
  <v-tooltip top
    v-for='(space, index) in selectedSpaces'
    :key='`${space.id}-${index}`' >
    <template v-slot:activator="{ on }">
      <v-avatar
        v-on='on'
        class='ml-1'
        :color='space.color'
        :size='size' >
        <v-img v-if='space.logo_picture' :src='imageKitUrl(space.logo_picture, "n-avatar")' >
        </v-img>
        <span class='white--text' v-else >
          <template v-if='space && space.title' >{{ space.title[0] }}</template>
        </span>
      </v-avatar>
    </template>
    <span>{{ getTitle(space) }}</span>
  </v-tooltip>
</span>
</template>
<script>
import SpacePicker from '@/components/pickers/SpacePicker'

export default {
  props: {
    spaceIds: { type: Array },
    spaces: { type: Array },
    size: { type: Number, default: 28 },
    tooltipPrefix: { type: String }
  },
  name: 'SpaceFaces',
  components: {SpacePicker},
  data () {
    return {
      fab: false,
      editspaces: false
    }
  },
  methods: {
    getTitle (space) {
      if (!space) { return '' }
      if (this.tooltipPrefix) {
        return `${this.tooltipPrefix} ${space.title}`
      }
      return space.title
    }
  },
  computed: {
    allSpaces () {
      return this.$store.getters.spaces
    },
    selectedSpaces () {
      if (this.spaces) { return this.spaces }
      if (this.spaceIds) {
        return this.allSpaces.filter((space) => {
          let stringSearch = this.spaceIds.indexOf(space.id.toString()) >= 0
          let intSearch = this.spaceIds.indexOf(parseInt(space.id)) >= 0
          return (stringSearch || intSearch)
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// SpaceFaces.vue?0b9a4ac6